import { AiccSystemSettings } from "types/model/aiccCustomer";

export interface UsageLimitRow {
  key: keyof AiccSystemSettings;
  userType: string;
  unit: string;
}

export const USAGE_LIMIT_ROWS: UsageLimitRow[] = [
  {
    key: "freeUserMessageLimit",
    userType: "Free User",
    unit: "messages / Lifetime",
  },
  {
    key: "paidUserDailyMessageLimit",
    userType: "All Access User",
    unit: "messages / Day",
  },
];

export const PAGE_DESCRIPTION = "System-wide default message limits, applied to all languages at the customer level.";

export const UPDATE_CONFIRMATION =
  "Are you sure you want to update this usage limit?\nThis change will apply globally. It will instantly update the available message quotas for all existing users and will become the default limit for all future users.";
